import './RubricaPage.css'

import Col from 'react-bootstrap/esm/Col'
import Container from 'react-bootstrap/esm/Container'
import Table from 'react-bootstrap/esm/Table'
import Alert from 'react-bootstrap/esm/Alert'
import Row from 'react-bootstrap/esm/Row'

import { useHistory, useLocation } from 'react-router-dom'
import SeMenu from '../components/SeMenu'
import SeHeroUser from '../components/SeHeroUser'
import { useEffect } from 'react'
import Button from 'react-bootstrap/esm/Button'

import 'react-circular-progressbar/dist/styles.css'

import { BsStar } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { useContext } from 'react'
import { AnchorsContext } from '../context/shared/AnchorsContext'
import { UserContext } from '../context/shared/UserContext'

export default function CertificatesPage() {
	const { anchors, currentAnchor, certificates } = useContext(AnchorsContext)
	const { user } = useContext(UserContext)

	return (
		<Container className="se-container-page">
			<SeHeroUser />
			<section className="se-section se-section-rubrica">
				<SeMenu />
				<div className="wrapper">
					<Row className="pt-3">
						<Col md={1} style={{ padding: '5px 30px' }}>
							<IconContext.Provider value={{ color: 'gray', size: '40px' }}>
								<div>
									<BsStar />
								</div>
							</IconContext.Provider>
						</Col>
						<Col md={11}>
							<h4 className="mb-0">Certificados o Constancias a descargar</h4>
							<p>
								Estas son todas las opciones disponibles para <u>{user.userEmail}</u>
							</p>
						</Col>
					</Row>
					{certificates?.length > 0 ? (
						<Row>
							<Col md={12} className="pt-3">
								<Table striped bordered hover>
									<thead>
										<tr>
											<th className="col-md-6">Titulo</th>
											<th className="col-md-2">Fecha</th>
											<th className="col-md-2">Descarga</th>
										</tr>
									</thead>
									<tbody>
										{certificates.map((certificate, index) => (
											<tr key={index}>
												<td>{certificate.name}</td>
												<td>{certificate.start}</td>
												<td>
													<a href={certificate.url}>
														<Button
															size="sm"
															variant="success"
															style={{ backgroundColor: '#87c053', color: '#000', borderColor: 'transparent' }}
														>
															<AiOutlineFilePdf style={{ position: 'relative', bottom: '1px' }} />
															&nbsp;Descargar PDF
														</Button>
													</a>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</Col>
						</Row>
					) : (
						<Row className="pt-3">
							<Col md={12} className="text-center">
								<Alert variant="warning">Lo sentimos, no encontramos ningún certificado para descargar. Regresa más tarde</Alert>
							</Col>
						</Row>
					)}

					{/* main content */}
					{/* main content */}
				</div>
			</section>
		</Container>
	)
}
